// noinspection JSUnusedGlobalSymbols

// A self-contained mirror of react-native-purchases-ui's PAYWALL_RESULT (a
// stable string enum), so this web mock pulls in no native RevenueCat code and
// no undeclared package. The native build re-exports the real enum; on web the
// paywall flow is a no-op that only ever resolves NOT_PRESENTED.
export enum PAYWALL_RESULT {
  NOT_PRESENTED = 'NOT_PRESENTED',
  ERROR = 'ERROR',
  CANCELLED = 'CANCELLED',
  PURCHASED = 'PURCHASED',
  RESTORED = 'RESTORED'
}

export const RevenueCatUI = {
  presentCustomerCenter: () => {
    if (__DEV__) {
      console.debug('[revcat] presentCustomerCenter called on web - no-op')
    }
  },
  presentPaywall: (_params?: unknown): Promise<PAYWALL_RESULT> => {
    if (__DEV__) {
      console.debug('[revcat] presentPaywall called on web - no-op')
    }

    return Promise.resolve(PAYWALL_RESULT.NOT_PRESENTED)
  }
}
